import { memo } from 'react';

/**
 * BrandWord — renders a brand-prefixed term with a softer prefix
 * ("BUX" / "BUXAP") and a heavier suffix ("SALE", "BAG", "CLUB", …).
 * Always English, LTR, never translated.
 *
 * Example: <BrandWord prefix="BUX" suffix="SALE" />  → BUX•SALE
 */
function BrandWordInner({
  prefix = 'BUX',
  suffix,
  className = '',
}: {
  prefix?: 'BUX' | 'BUXAP';
  suffix: string;
  className?: string;
}) {
  return (
    <span
      lang="en"
      dir="ltr"
      className={`inline-flex items-baseline whitespace-nowrap ${className}`}
    >
      <span className="font-light opacity-70 tracking-[0.18em]">{prefix}</span>
      <span className="font-bold tracking-[0.22em]">{suffix}</span>
    </span>
  );
}

export const BrandWord = memo(BrandWordInner);
export default BrandWord;
